import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { checkScore } from '../actions/warranty';

import { useHistory } from 'react-router-dom';
import Button from '../components/ui/Button/Button';
import days from '../img/1-warranty.svg';
import box from '../img/2-warranty.svg';
import parties from '../img/3-warranty.svg';
import damprod from '../img/4-warranty.svg';
import cosmdprod from '../img/5-warranty.svg';
import consumables from '../img/6-warranty.svg';
import donotcovermobile from '../img/does_not_cover_mobile.png';
import donotcover from '../img/donotcover.png';
import donotcovermobile1 from '../img/dont_quit_mobile_1.png';
import donotcovermobile2 from '../img/dont_quit_mobile_2.png';
import dontquit from '../img/dontquit.png';
import banner from '../img/new_warranty_banner.png';
import bannerMobile from '../img/warranty_banner_mobile.png';

const info = [
  {
    text: 'Products not registered within 60 days of order placement',
    img: days,
  },
  { text: 'Products bought in used condition, open boxes', img: box },
  {
    text: 'Products purchased from 3rd parties if you cannot provide the order number and the date it was placed',
    img: parties,
  },
  { text: 'Lost, stolen, or deliberately damaged products', img: damprod },
  { text: 'Products with cosmetic damages', img: cosmdprod },
  {
    text: 'Any consumables (batteries, cartridges, fuel, etc.)',
    img: consumables,
  },
];

const Home = () => {
  const history = useHistory();

  return (
    <div className='home-container'>
      <img src={banner} alt='warranty logo' className='home-logo' />
      <section className='home-description'>
        <p className='home-description-row'>
          <span>All GRITR products come with a One-Year Limited Warranty.</span>
        </p>
        <div className='home-description-row mt-10'>
          <h3 className='section-title-bold--orange'>But why stop there?</h3>
        </div>
        <p className='home-description-row mt-10 text-block-wide'>
          <span>
            At GRITR, we don't believe in limits, so we introduce our "UNLIMITED
            GRITR" Lifetime Warranty – we've got your back, no matter what. If
            your gear becomes damaged or defective during intended use, GRITR
            will repair it free of charge. If repair is not possible, we will
            replace your product with an equal or superior model. It's unlimited
            support for your unlimited adventures.
          </span>
        </p>
        <div className='home-description-row flex-column'>
          <h3 className='section-title-bold--orange'>
            Ready for lifetime protection?
          </h3>
          <h3 className='section-title-bold--white'>
            Just fill out the form below and enjoy the benefits of our Lifetime
            Warranty.
          </h3>
        </div>
      </section>

      <section className='home-actions'>
        <Button
          className='home-button'
          onClick={() => history.push('/register/')}
        >
          GET LIFETIME WARRANTY*
        </Button>
        <p className='home-descr-extra mt-45'>
          <span>
            *You can register the UNLIMITED GRITR Warranty within 60 days of
            placing your order.
          </span>
        </p>
      </section>

      <section className='home-actions-box'>
        <img src={donotcover} alt='warranty logo' className='home-img-cover' />
        <div className='home-cover-warranty'>
          <span className='section-title section-title-white mb-29'>
            UNLIMITED GRITR LIFETIME WARRANTY <br />
            <span className='text-accent'>DOES NOT</span> COVER
          </span>
          <div className='home-info'>
            {info.map((data, i) => (
              <div className='home-info-box' key={i}>
                <img
                  src={data.img}
                  alt={data.text}
                  className='home-info-icon'
                />
                <span className='font-medium'>{data.text}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className='home-description home-description2 align-center'>
        <div className='home-description-row flex-column-gapped'>
          <h3 className='section-title-bold--orange'>
            Need a repair or replacement?
          </h3>
          <h3 className='section-title-bold--white'>
            No problem! Just fill out the form below and attach photos of the
            issue.
          </h3>
        </div>
        <Button className='home-button' onClick={() => history.push('/case/')}>
          GET HELP NOW
        </Button>
        <p className='home-descr-extra mt-40'>
          <span>
            Our specialists will review your submission and reach out with the
            next steps.
          </span>
        </p>
      </section>

      <section className='home-actions-box'>
        {<img src={dontquit} alt='warranty logo' className='home-logo' />}
      </section>
    </div>
  );
};

const mapStateToProps = (state) => ({
  warranty: state.warranty,
});

export default connect(mapStateToProps, { checkScore })(Home);
